import { isFeatureActive } from '@silverfort-nodelibs/common/utils/common';
import { FEATURE_FLAGS_NAMES } from '@silverfort-nodelibs/common/utils/consts';

import useFeature from '../../components/SystemSettings/hooks/featureFlags/useFeature';
import { Pages, Roles } from '../../context/contexts/UserContext/permissionsTypes';
import useHasPermissions from '../../hooks/useHasPermissions';
import AIAssistantPage from '../../modules/aiAssistant/AIAssistantPage';
import { LogicalRoute, LogicalRouteImportProps } from '../helpers/LogicalRoute';

export const AIAssistantRouting = (props: LogicalRouteImportProps) => {
    const aiAssistantFlag = useFeature(FEATURE_FLAGS_NAMES.AIAssistant);
    const hasPermission = useHasPermissions({ permission: Pages.AI_ASSISTANT, role: Roles.VIEWER });
    const enabled = isFeatureActive(aiAssistantFlag) && hasPermission;
    return <LogicalRoute {...props} component={AIAssistantPage} isNotFound={!enabled} />;
};
